import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { pulizieApi, erroreApi } from './api';

export const AllergeniDialog = ({ open, allergeni, operatore, onClose, onSaved }) => {
  const [scelti, setScelti] = useState([]);
  const [attrezzature, setAttrezzature] = useState('');
  const [busy, setBusy] = useState(false);

  const toggle = (a) => setScelti((s) => (s.includes(a) ? s.filter((x) => x !== a) : [...s, a]));

  const salva = async () => {
    setBusy(true);
    try {
      await pulizieApi.post('/allergeni', { allergeni: scelti, attrezzature, operatore });
      toast.success('Pulizia dopo allergeni registrata');
      setScelti([]); setAttrezzature('');
      onSaved();
    } catch (e) {
      toast.error(erroreApi(e, 'Non sono riuscito a salvare'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl max-h-[88vh] overflow-y-auto" data-testid="pulizie-allergeni-dialog">
        <DialogHeader>
          <DialogTitle>Pulizia dopo gli allergeni</DialogTitle>
          <DialogDescription>Dopo aver lavorato allergeni pulisci attrezzature e piani e controlla che non restino residui.</DialogDescription>
        </DialogHeader>
        <p className="text-sm font-medium">Quali allergeni? <span className="text-gray-500 font-normal">(facoltativo)</span></p>
        <div className="flex flex-wrap gap-2">
          {allergeni.map((a) => (
            <button key={a} onClick={() => toggle(a)} data-testid={`pulizie-allergene-${a.toLowerCase().replace(/\s+/g, '-')}`}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${scelti.includes(a) ? 'bg-violet-600 border-violet-600 text-white' : 'border-gray-300 hover:bg-gray-100'}`}>
              {a}
            </button>
          ))}
        </div>
        <Input value={attrezzature} onChange={(e) => setAttrezzature(e.target.value)}
          placeholder="Attrezzature pulite (es. impastatrice, tagliere)" data-testid="pulizie-allergeni-attrezzature" />
        <Button onClick={salva} disabled={busy} className="h-11 bg-violet-600 hover:bg-violet-700 text-white"
          data-testid="pulizie-allergeni-salva">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Pulito, nessun residuo visibile'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
